import React from "react";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import NewAdds from "./NewAdds/NewAdds";
import MyAdds from "./MyAdds/MyAdds";
import { useSelector } from "react-redux";
import { ZeroEvents } from "../../ClientScreens/Events/Events";

const items = [
  {
    key: "1",
    label: "New Ads",
    children: <NewAdds />,
  },
  {
    key: "2",
    label: "My Ads",
    children: <MyAdds />,
  },
];

const Advertisement = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  return (
    <>
      <BoxTabs items={items} />
      <ZeroEvents
        isModalOpen={!user?.is_subscribed}
        // setIsModalOpen={setIsModalOpen}
        closable={false}
      />
    </>
  );
};

export default Advertisement;
